'use client'

// @ts-strict-ignore
import Script from 'next/script'
import { ReactNode, useState } from 'react'

import { YaPayContext } from '../context/YaPayContext'

interface YaPayProps {
	children: ReactNode
}

export const YaPayProvider = (props: YaPayProps) => {
	const { children } = props

	const [isYaPayLoaded, setIsYaPayLoaded] = useState(false)

	const onYaPayLoad = () => {
		if (window.hasOwnProperty('YaPay')) {
			setIsYaPayLoaded(true)
		}
	}

	return (
		<>
			<YaPayContext.Provider value={isYaPayLoaded}>{children}</YaPayContext.Provider>
			<Script src="https://pay.yandex.ru/sdk/v1/pay.js" onLoad={onYaPayLoad} strategy="lazyOnload" />
		</>
	)
}
